import { render } from "./BienImmos.vue?vue&type=template&id=7fe574d2"
import script from "./BienImmos.ts?vue&type=script&lang=js"
export * from "./BienImmos.ts?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__